import React from "react";

function Footer() {
  return (
    <footer className="footer-section text-center py-4">
      <div className="container">
        <p className="mb-2 fw-bold text-dark">
          
        @ 2025 VetConnect — Connecting Pets & Care with Love
        </p>
        <div className="social-icons">
          <i className="bi bi-facebook mx-2 text-primary fs-4"></i>
          <i className="bi bi-twitter mx-2 text-info fs-4"></i>
          <i className="bi bi-instagram mx-2 text-danger fs-4"></i>
          <i className="bi bi-linkedin mx-2 text-primary fs-4"></i>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
